import * as React from 'react';

export interface AudioPlayerProps {
  dataHook?: string;
  className?: string;
  src: string;
  format?: string;
  preload?: 'metadata' | 'auto' | 'none';
  autoplay?: boolean;
  webAudioAPI?: boolean;
  onLoad?(): void;
  onLoadError?(errorMsg: string): void;
  onPlay?(): void;
  onPause?(): void;
  onEnd?(): void;
  onSeek?(): void;
}

export type AudioPlayerImperativeActions = {
  focus(): void;
};

declare const AudioPlayer: React.FC<
  AudioPlayerProps & React.RefAttributes<AudioPlayerImperativeActions>
>;

export default AudioPlayer;
